 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED433 from '@/components/Untitled433'
 import UNTITLED434 from '@/components/Untitled434'
 import UNTITLED435 from '@/components/Untitled435'
 import UNTITLED436 from '@/components/Untitled436'
 import UNTITLED437 from '@/components/Untitled437'
 import UNTITLED438 from '@/components/Untitled438'
 import UNTITLED439 from '@/components/Untitled439'
 import UNTITLED440 from '@/components/Untitled440'
 import UNTITLED441 from '@/components/Untitled441'
 import UNTITLED442 from '@/components/Untitled442'
 import UNTITLED443 from '@/components/Untitled443'
 import UNTITLED444 from '@/components/Untitled444'
 import UNTITLED445 from '@/components/Untitled445'
 import UNTITLED446 from '@/components/Untitled446'
 import UNTITLED447 from '@/components/Untitled447'
 import UNTITLED448 from '@/components/Untitled448'
 import UNTITLED449 from '@/components/Untitled449'
 import UNTITLED450 from '@/components/Untitled450'
 import UNTITLED451 from '@/components/Untitled451'
 import UNTITLED452 from '@/components/Untitled452'
 import UNTITLED453 from '@/components/Untitled453'
 import UNTITLED454 from '@/components/Untitled454'
 import UNTITLED455 from '@/components/Untitled455'
 import UNTITLED456 from '@/components/Untitled456'
 import UNTITLED457 from '@/components/Untitled457'
 import UNTITLED458 from '@/components/Untitled458'
 import UNTITLED459 from '@/components/Untitled459'
 import UNTITLED460 from '@/components/Untitled460'
 import UNTITLED461 from '@/components/Untitled461'
 import UNTITLED462 from '@/components/Untitled462'
 import UNTITLED463 from '@/components/Untitled463'
 import UNTITLED464 from '@/components/Untitled464'
 import UNTITLED465 from '@/components/Untitled465'
 import UNTITLED466 from '@/components/Untitled466'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled433",
 			"name" : "Untitled433",
 			"component" : UNTITLED433
 		},
 		{
 			"path" : "/Untitled434",
 			"name" : "Untitled434",
 			"component" : UNTITLED434
 		},
 		{
 			"path" : "/Untitled435",
 			"name" : "Untitled435",
 			"component" : UNTITLED435
 		},
 		{
 			"path" : "/Untitled436",
 			"name" : "Untitled436",
 			"component" : UNTITLED436
 		},
 		{
 			"path" : "/Untitled437",
 			"name" : "Untitled437",
 			"component" : UNTITLED437
 		},
 		{
 			"path" : "/Untitled438",
 			"name" : "Untitled438",
 			"component" : UNTITLED438
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js